import StickyButton from '../modules/StickyButton'
import BaseController from './BaseController';

export default class HeaderController extends BaseController {

  init() {

    this.$ = {
      header: document.querySelector('.header'),
      burger: document.querySelector('.navigationBurger'),
      mobileNavigation: document.querySelector('.navigationItems'),
      quit: document.querySelector('.menu__quit'),
      menuItems: document.querySelectorAll('.header__navigation .navbar-item'),
      menuItemsMobile: document.querySelectorAll('.header__navigationMobile .navbar-item'),
      submenu: document.querySelectorAll('.sub-menu')
    }
    this.isMenuOpen = false
    this.submenu = [];
    this.submenuMobile = [];


    for(let i = 0; i < this.$.menuItems.length; i++) {
      let list = this.$.menuItems[i].querySelector('.sub-menu')
      if(this.$.menuItems[i].contains(list)){
        let submenu = {
          parent: this.$.menuItems[i],
          item: this.$.submenu[i]
        }
        this.submenu.push(submenu)
        this.$.header.appendChild(this.submenu[i].item)
      }
    }
    for(let i = 0; i < this.$.menuItemsMobile.length; i++) {
      let quitClone = this.$.quit.cloneNode(true);
      quitClone.addEventListener('click', () => this.hideMenu())
      let back = this.addReturn()
      back.addEventListener('click', () => this.hideSubmenu())
      let list = this.$.menuItemsMobile[i].querySelector('.sub-menu')
      if(this.$.menuItemsMobile[i].contains(list)){
        let submenu = {
          parent: this.$.menuItemsMobile[i],
          item: list
        }
        this.submenuMobile.push(submenu)
        this.submenuMobile[i].item.appendChild(quitClone, back)
        this.submenuMobile[i].item.appendChild(back)
        this.$.header.appendChild(this.submenuMobile[i].item)
      }
    }

    
    this.createMenuUnderlines()
    this.revealAnimate()
    this.listeners()
    this.touchmoves()
    this.memberIcon()
    if (window.innerWidth >= 640 && !document.body.classList.contains('page-template-template_sport')) this.hideHeader()
    if (document.body.classList.contains('page-template-template_sport')) this.disableNoiseHeader()

    new StickyButton('.cta')
  }


  listeners() {
    this.$.burger.addEventListener('click', () => this.showMenu())
    this.$.quit.addEventListener('click', () => this.hideMenu())
    const $menuItems = document.querySelectorAll('.header .navbar-item a')
    for (let i = 0; i < $menuItems.length; i++) {
        $menuItems[i].addEventListener('mouseenter', () => { this._handleEnterMenuItem(i) })
        $menuItems[i].addEventListener('mouseleave', () => { this._handleLeaveMenuItem(i) })
    }

    for(let i = 0; i < this.submenu.length; i++){
      if (window.innerWidth < 769) this.$.header.removeChild(this.submenu[i].item)
      this.submenu[i].parent.addEventListener('mouseenter', (event) => {
        event.stopPropagation()
        this.submenu[i].item.classList.add("active")
      })
      this.submenu[i].item.addEventListener('mouseenter', () => {
        this.submenu[i].item.classList.add("active")
      })
      this.submenu[i].item.addEventListener('mouseleave', () => {
        this.submenu[i].item.classList.remove("active")
      })
    }
    
    for(let i = 0; i < this.submenuMobile.length; i++){
      if (window.innerWidth > 1000) this.$.header.removeChild(this.submenuMobile[i].item)
      this.submenuMobile[i].item.classList.add("submenu--mobile")
      this.submenuMobile[i].parent.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopPropagation()
        this.submenuMobile[i].item.classList.toggle("activeMobile")
      })
      
    }

  }

  createMenuUnderlines() {
    if (window.innerWidth < 769) return
    const $menuItems = document.querySelectorAll('.header .navbar-item')
    for (let i = 0; i < $menuItems.length; i++) {
      const $underline = document.createElement('div')
      $underline.classList.add('menu-item__underline')
      $menuItems[i].appendChild($underline)
    }
  }

  _handleEnterMenuItem(i) {
    const $underlines = document.querySelectorAll('.header .menu-item__underline')
    const $underline = $underlines[i]
    this.underlineTimeline = new TimelineMax({onComplete:function() { this.restart(); }})
    this.underlineTimeline
      .to($underline, .1, {
        scaleX: 1,
        transformOrigin: 'left',
        backgroundColor: '#FBB4C4',
        ease: Power1.easeOut
      })
      .to($underline, .1, {
        scaleX: 0,
        transformOrigin: 'right',
        backgroundColor: '#FBB4C4',
        ease: Power1.easeOut
      })
      .to($underline, .1, {
        scaleX: 1,
        transformOrigin: 'left',
        backgroundColor: '#FF5869',
        ease: Power1.easeOut
      })
      .to($underline, .1, {
        scaleX: 0,
        transformOrigin: 'right',
        backgroundColor: '#FF5869',
        ease: Power1.easeOut
      })
      .to($underline, .1, {
        scaleX: 1,
        transformOrigin: 'left',
        backgroundColor: '#FFCD00',
        ease: Power1.easeOut
      })
      .to($underline, .1, {
        scaleX: 0,
        transformOrigin: 'right',
        backgroundColor: '#FFCD00',
        ease: Power1.easeOut
      })
      .to($underline, .1, {
        scaleX: 1,
        transformOrigin: 'left',
        backgroundColor: '#5C7E51',
        ease: Power1.easeOut
      })
      .to($underline, .1, {
        scaleX: 0,
        transformOrigin: 'right',
        backgroundColor: '#5C7E51',
        ease: Power1.easeOut
      })
  }

  _handleLeaveMenuItem(i) {
    this.underlineTimeline.pause()
    const $underlines = document.querySelectorAll('.header .menu-item__underline')
    TweenMax.to($underlines[i], .1, {
      scaleX: 0,
      transformOrigin: 'right',
      ease: Power1.easeOut
    })
  }

  disableNoiseHeader()
  {
    this.$.header.style.background = 'none'
    this.$.header.classList.add('black')
    // this.$.header.style.backgroundColor = 'white'
  }

  hideHeader() {
    let isVisible = true
    window.addEventListener('mousewheel', (event) => {
      if (event.deltaY >= 0) {
        isVisible = false
        TweenMax.to('.header__navigation', .5, { y: '-150%', ease: Power1.easeOut })
        TweenMax.to('.header__logo', .5, { y: '-150%', ease: Power1.easeOut })
        TweenMax.to('.header', .5, { y: '-150%', ease: Power1.easeOut })
        // TweenMax.to('.header__logo', .3, { scale: .6, ease: Power1.easeOut })
      }
      if (event.deltaY < 0) {
        isVisible = true
        TweenMax.to('.header__navigation', .5, { y: '0%', ease: Power1.easeOut })
        TweenMax.to('.header__logo', .5, { y: '0%', ease: Power1.easeOut })
        TweenMax.to('.header', .5, { y: '0%', ease: Power1.easeOut })
        // TweenMax.to('.header__logo', .3, { scale: 1, ease: Power1.easeOut })
      }
    })
  }

  revealAnimate() {
    const $current = document.querySelector('.current-menu-item')
    const $underline = document.createElement('div')
    $underline.classList.add('menu-item-underline')
    if ($current) {
      $current.appendChild($underline)
    }

    const timeline = new TimelineMax({ delay: .8 })

    timeline
      .staggerFrom(this.$.menuItems, .5, {
          y: '100%',
          opacity: 0,
          ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
        }, .12, 'homeLoading'
      )
      .from('.header__logo', .5, {
          x: '20px',
          opacity: 0,
          ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
        }, 'homeLoading'
      )
      .to($underline, .5, {
          scaleX: 1,
          ease: Power1.easeOut
        }, 'homeLoading+=.5'
      )

      if (document.querySelector('.header__account--svgBorder svg') !== null) {
                timeline.add(
                    TweenMax.fromTo('.member-image', .8, {
                        opacity: 0,
                        ease: Power1.easeOut
                    },   {
                        opacity: 1
                    }, 'homeLoading+=.4')
                )
                timeline.add(
                    TweenMax.to(document.querySelector('.header__account--svgBorder svg'), .8, {
                        strokeDashoffset: 0,
                        ease: Power1.easeOut
                    }, 'homeLoading+=.4')
                )
            }
  }

  showMenu() {
    TweenMax.to(this.$.mobileNavigation, .3,
      { x: `-${window.innerWidth}`, ease: Power1.easeOut }
    )
    document.body.classList.add('fixed')
    this.isMenuOpen = true
  }

  hideMenu() {
    TweenMax.to(this.$.mobileNavigation, .3,
      { x: 0, ease: Power1.easeOut }
    )
    document.body.classList.remove('fixed')
    this.hideSubmenu()
    this.isMenuOpen = false
  }

  hideSubmenu() {
    for(let i = 0; i < this.$.submenu.length; i++) {
      if(this.$.submenu[i].classList.contains('activeMobile')){
        this.$.submenu[i].classList.remove('activeMobile')
      }
    }
  }

  addReturn() {
    let back = document.createElement('div');
    back.classList.add('menu__back');
    back.style.position = "absolute"
    back.style.top = "3vh"
    back.style.left = "10vw"
    back.style.width = "20px"
    back.style.height = "30px"
    back.style.backgroundImage = "url(../wp-content/themes/la_mongolfiere/assets/images/global/icons/menuArrow.svg)"
    back.style.backgroundSize = "contain"
    back.style.backgroundRepeat = "no-repeat"

    return back
  }

  memberIcon() {
    for (const $item of this.$.menuItems) {
      if ($item.innerText.includes('compte') || $item.innerText.includes('membre')) {
        $item.innerHTML = '<div class="header__account" onclick="window.location = \'/dashboard\'"><span class="member-image"></span>mon compte</div>'
        break
      }
    }
  }

  touchmoves() {
    let isTouching = false
    let distance = 0
    let start = null
    this.$.mobileNavigation.addEventListener('touchstart', (e) => {
      start = e.touches[0].screenX
      isTouching = true
    })
    this.$.mobileNavigation.addEventListener('touchend', (e) =>  {
      if (distance >= 100) this.hideMenu()
      else this.showMenu()
      isTouching = false
      distance = 0
      start = null
    })
    this.$.mobileNavigation.addEventListener('touchmove', (e) => {
      if (isTouching) {
        distance = e.touches[0].screenX - start

        if (distance >= 10) {
          TweenMax.to(this.$.mobileNavigation, .3,
            { x: `${-window.innerWidth + distance}px`, ease: Power1.easeOut }
          )
        }
      }
    })
  }
}